import { InputHTMLAttributes, forwardRef } from "react";
import { cn } from "../../lib/cn";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  hint?: string;
  error?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, label, hint, error, id, ...props }, ref) => {
    const inputId = id ?? label?.toLowerCase().replace(/\s+/g, "-");

    return (
      <div className="flex w-full flex-col gap-1.5">
        {label && (
          <label
            htmlFor={inputId}
            className="text-sm font-medium text-content-primary"
          >
            {label}
          </label>
        )}
        <input
          ref={ref}
          id={inputId}
          className={cn(
            "h-10 w-full rounded-lg border border-border bg-surface px-3 text-sm text-content-primary",
            "placeholder:text-content-muted",
            "transition-colors duration-150",
            "hover:border-border-strong",
            "focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/20",
            "disabled:cursor-not-allowed disabled:bg-surface-muted disabled:text-content-muted",
            error && "border-status-danger focus:border-status-danger focus:ring-status-danger/20",
            className
          )}
          {...props}
        />
        {hint && !error && (
          <p className="text-xs text-content-muted">{hint}</p>
        )}
        {error && (
          <p className="text-xs text-status-danger">{error}</p>
        )}
      </div>
    );
  }
);

Input.displayName = "Input";
